import { IpcResponse } from './general/models/ipc-response.interface';

export interface IpcData {
	serialnumber: string;
	biosrelease: string;
	uuid: string;
	runs: number;
	totalRuns: number;
	start: number;
	modemIp: string;
	wifiIp: string;
	timeAvg: number;
	signalLow: number;
	signalAvg: number;
	memsize: number;
	diskSpeed: number;
	status: string;
	carrierId: string;
	iccid: string;
	modemStatus: string;
	latest: number;
	mac: string;
	raw: IpcResponse;
}

const parseStatus = (data: IpcResponse): string => {
	if (!data?.modem?.status) return 'pending';

	const hasRuns = data?.run > 0 || data?.total_runs > 0;
	const allSuccessful =
		data?.total_runs === data?.run ||
		(data?.modem?.successful > 0 && data?.run === data?.modem?.successful);

	if (hasRuns && allSuccessful) return 'success';
	return 'failed';
};

export const parseIpcData = (data: IpcResponse): IpcData => {
	return {
		serialnumber: data?.ipc?.serialnumber,
		biosrelease: data?.ipc?.biosrelease,
		uuid: data?.ipc?.uuid,
		runs: data?.run,
		totalRuns: data?.total_runs,
		start: data?.start * 1000,
		modemIp: data?.modem?.ip,
		wifiIp: data?.wifi?.ip,
		timeAvg: data?.modem?.time_avg,
		signalLow: data?.modem?.low_signal,
		signalAvg: data?.modem?.signal_avg,
		memsize: data?.ipc?.memsize / 1e9,
		diskSpeed: data?.disk?.speed,
		status: parseStatus(data),
		carrierId: data?.modem?.carrier_id ?? '',
		iccid: data?.modem?.iccid ?? '',
		modemStatus: data?.modem?.status ?? '',
		latest: data?.latest * 1000,
		mac: data?.wifi?.hwaddress ?? '',
		raw: data,
	};
};
